export interface INotification {
  Type: NotificationType;
  Message: string;
  Payload?: any;
}

export enum NotificationType {
  analytics = 'analytics',
  information = 'information',
  error = 'error',
  coBuyerActivation =  'coBuyerActivation',
  coBuyerDeactivation = 'coBuyerDeActivation',
  clearPreviousResidence = 'clearPreviousResidence',
  reviewTriggered = 'reviewTriggered',
  bankRequest = 'bankRequest',
  confirmation = 'confirmation',
  startingNewCreditApp = 'newcreditappstarted'
}
